import reducer from './ScoreTicker';

export default reducer;
